module.exports = __webpack_public_path__ + "static/face-dark-da95a563c7e26d45b50ba235e6f9be3b.png";